import { render } from "./Header.vue?vue&type=template&id=54ecad5f&scoped=true"
import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"

import "./Header.vue?vue&type=style&index=0&id=54ecad5f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ecad5f"],['__file',"src/containers/main/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54ecad5f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54ecad5f', __exports__)) {
    api.reload('54ecad5f', __exports__)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=54ecad5f&scoped=true", () => {
    api.rerender('54ecad5f', render)
  })

}


export default __exports__